import { Slider as MUISlider, styled } from "@mui/material";
const Slider = styled(MUISlider)(({ theme }) => ({
    color: 'primary.main',
    width: '80%',
    display: 'flex',
    marginLeft: '3%',
    marginTop: '8%',
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: '12px',
        background: 'unset',
        padding: '0px',
        width: '32px',
        height: '32px',
        borderRadius: '50% 50% 50% 0',
        backgroundColor: theme.palette.primary.main,
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
}));
export default Slider;
